import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDaily, useDevices } from '@daily-co/daily-react';
import {
  pageAtom,
  isAuthAtom,
  cameraInputAtom,
  micInputAtom,
  twitterAtom,
  myNftAtom,
  displayNameAtom,
} from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Faq from 'react-faq-component';

export default function FAQ() {
  const data = {
    rows: [
      {
        title: 'How many persons can join a meeting on Faceless?',
        content: `Currently, the platform can support up to 6 people.`,
      },
      {
        title: 'How can I use the Live mode?',
        content:
          'The Live mode allows you to do an online meeting with up to 1000 participants. For the moment, since it’s the Beta version, we have a limit number of users who access to this option.',
      },
      {
        title: 'How long can last an online meeting?',
        content: 'For the moment, it’s unlimited since it’s the Closed Beta version.',
      },
      {
        title: 'Can I invite my friends or colleagues?',
        content: `Yes, you can invite anyone as long as you are the host. However, if the participants want to have their own meeting URL, we would advice them to apply for an access pass on our platform : <a href="https://faceless.ooo/" target="_blank">https://faceless.ooo/</a>`,
      },
      {
        title: 'How can I use my NFT on Faceless?',
        content:
          'If you are currently holding a NFT and would like to use it in video calls, please fill out this <a href="https://faceless.ooo/access" target="_blank">form</a>. If you’re selected, you might get a free animation!',
      },
      {
        title: 'I connected my Wallet, but I could not find my NFT in the list',
        content: `Please, check if your NFT is really in the Wallet that you have connected. It’s important to know that we also support Etherum and Polygon chain`,
      },
      {
        title: 'How much does it cost to use Faceless',
        content: `Since it’s the Closed Beta Version, the platform is for free.`,
      },
    ],
  };

  const styles = {
    bgColor: 'transparent',
    titleTextColor: '#fff',
    titleTextSize: '24px',
    rowTitleColor: '#fff',
    rowTitleTextSize: '14px',
    rowContentColor: '#fff',
    rowContentTextSize: '13px',
    rowContentPaddingTop: '0px',
    rowContentPaddingBottom: '20px',

    // rowContentPaddingLeft: '50px',
    // rowContentPaddingRight: '150px',
    arrowColor: '#ae81ff',
    //transitionDuration: "1s",
    // timingFunc: "ease"
  };

  return (
    <>
      <div id="faqSetting">
        <div className="settingTitle">FAQ </div>
        <Faq data={data} styles={styles} />
      </div>
    </>
  );
}
